import { ICarReviewLink } from 'app/apiCalls/kentico';
import { LinkSt } from 'app/shared/components/ModelReview/OtherModelsReviews/ReviewLink.css';

export interface IReviewLinkProps {
  reviewLink: ICarReviewLink;
}

export const ReviewLink = ({ reviewLink }: IReviewLinkProps) => {
  const url = `/${reviewLink.slug}`;
  return (
    <LinkSt href={url}>
      {reviewLink.make} {reviewLink.model}
    </LinkSt>
  );
};
